import { Resizable } from 're-resizable';
import styled from 'styled-components';

export const Container = styled(Resizable)`
  background-color: #fff;
  display: flex;
  flex-direction: column;
  filter: drop-shadow(0px 5.64865px 16.9459px rgba(88, 94, 102, 0.18));
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;


  .right-anchor-resizable {
    
    z-index: 99999;
    background: #585e66;
    border-radius: 8px;
    width: 15px !important;

    &:after{
      position: absolute;
      content: '';
      top: calc(50% - 15px);
      left: 25%;
      height: 30px;
      border: 1.2px solid #FFF8DC;
      filter: brightness(0.8)
    }

    &:before{
      position: absolute;
      content: '';
      top: calc(50% - 15px);
      left: 60%;
      height: 30px;
      border: 1.2px solid #FFF8DC;
      filter: brightness(0.8)
    }

    &:hover{
        filter: brightness(0.8)
    }

  }
`;

export const Header = styled.div`
  width: 100%;
  margin-top: 1.825rem;
  overflow: hidden;

  display: flex;
  align-items: center;
  justify-content: space-between;
`;



export const Box = styled.div`

  display: flex;
  flex-direction: column;
  align-items: center;

  border-radius: 0.5rem;
  margin-right: 1rem;

  width: 7.061rem;
  height: 5.2954167rem;
  background: #585e66;
  justify-content: space-evenly;
  user-select: none;

  h2{
    width: 1rem;
    margin: 0;
    color: #fff;
  }

  span{
    display: block;
    font-size: 0.8rem;
  
    color: #a9aeb4;
    font-weight: bold;

  }

  div{
    width: 100%;
    display: flex;
    justify-content: space-around;

  }

  button{
    background-color: #40e5a0;
    border: none;
    width: 1.75rem;
    height: 1.75rem;
    border-radius: 50%;
    cursor: pointer;
  }


`;

export const MinusButton = styled.button`

  position: relative;

  &:before{
    position: absolute;
    content: '';
    border-radius: 12px;
    left: 0;
    top: 45%;
    transform: translateX(35%);
    width: 60%;
    height: 15%;
    background: #585e66;

  }



`;
export const PlusButton = styled.button`

  position: relative;


  &:before{
    position: absolute;
    content: '';
    border-radius: 12px;
    left: 0;
    top: 45%;
    transform: translateX(35%);
    width: 60%;
    height: 15%;
    background: #585e66;

  }
  &:after{
    position: absolute;
    content: '';
    border-radius: 12px;
    left: 45%;
    top: 0;
    transform: translateY(35%);
    width: 15%;
    height: 60%;
    background: #585e66;

  }




`;


export const ProjectTitle = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 1.82rem;
  user-select: none;

  strong {
    font-size: 1.4125rem;
    color: #212326;
    line-height: 1.8625rem;
    margin-bottom: 0.917rem;
  }

  span {
    font-size: 1.4125rem;
    color: #a9aeb4;
    font-weight: bold;
    line-height: 1.645833rem;
  }
`;

export const StatusInfo = styled.div`
  display: flex;
  width: 28.54rem;
  height: 2.833rem;

  align-items: center;
  flex-wrap: wrap;
  user-select: none;
`;

export const Label = styled.span`
  font-size: 0.90625rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #212326;
  font-weight: 600;
  margin-right: 1.75667rem;
  line-height: 1rem;

  &:before {
    content: ' ';
    display: flex;
    align-self: center;

    width: 0.5229rem;
    height: 0.5229rem;
    margin-right: 0.354167rem;
    border-radius: 50%;

    background: ${({ status }) =>
    status === 'doneStatus'
      ? 'linear-gradient(126.53deg, #40E5A0 0%, #118052 100.09%)'
      : status === 'pendingStatus'
        ? 'linear-gradient(126.53deg, #EFF1F5 0%, #A9AEB4 100.09%)'
        : status === 'doingStatus'
          ? 'linear-gradient(126.53deg, #EACB29 0%, #D3BA38 100.09%)'
          : status === 'doneLateStatus'
            ? 'linear-gradient(126.53deg, #40E5A0 0%, #BC1010 86.53%)'
            : 'linear-gradient(126.53deg, #D93333 0%, #C92323 100.09%)'};
  }
`;

export const TaskCounter = styled.div`
  width: 7.061rem;
  height: 5.2954167rem;
  background: #585e66;
  margin-right: 1.82rem;
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  user-select: none;

  h1,h2, h4{
    margin: 0;
  }


  h2 {
    font-size: 1.5rem;
    color: #fff;
    font-weight: 700;
  }

  h4 {
    color: #a9aeb4;
    font-size: 0.8rem;
  }
`;

export const ProgressBar = styled.div`
  width: 5.76625rem;
  height: 0.235416rem;
  background: #7e858f;
  border-radius: 0.3rem;
`;
export const ProgressTask = styled.div`
  height: 100%;
  width: ${({ value }) => value};
  background: #40e5a0;
  border-radius: 0.3rem;
`;
